export const toggleFilterTrigger = (isScrollingUp) => {
    const headerFilterTrigger = document.querySelector(".l-header__filter-trigger");
    const shouldShow = document.querySelector(".c-filter__trigger");
    const listingFilter = document.querySelector('.l-listing__filter');

    if (!shouldShow || !headerFilterTrigger) return;

    if (isScrollingUp) {
        headerFilterTrigger.classList.add("hidden");
    } else {
        // Check if we're above the listing main element
        if (listingFilter) {
            const listingFilterTop = listingFilter.getBoundingClientRect().top + window.scrollY;
            if (window.scrollY < listingFilterTop) {
                headerFilterTrigger.classList.add("hidden");
            } else {
                headerFilterTrigger.classList.remove("hidden");
            }
        } else {
            headerFilterTrigger.classList.remove("hidden");
        }
    }
};
